/*
 * @Description: 项目参与人完成的任务区间分布
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_21_1 from './bi-tmpl-detail-21-1.vue';
export default BiTmplDetail_21_1;
